import { authenticatedAxios } from './axios';
import getVehicleSummariesQuery, {
  getVehicleSummariesLegacyQuery,
  type VehicleSummariesResponse
} from './GraphQL/queries/getVehicleSummaries';
import type { GQLError } from './resources';
import { customerReportVehicleOutcomeMutation } from './GraphQL/mutations/selfReport';

const endpoint = `${process.env.CARVANA_APP_BFF_API}/graphql/`;

// True when the BFF schema doesn't recognize `isTradeIn` yet (FE deployed ahead
// of the BFF change) — the whole query is rejected, not just one field.
const isUnknownIsTradeInField = (errors?: GQLError[]) =>
  errors?.some(
    error =>
      error.message?.includes('isTradeIn') &&
      /cannot query field|does not exist|unknown field/i.test(error.message)
  ) ?? false;

const AppraisalBffApi = {
  getSummaries: async () => {
    const postSummaries = (query: string) =>
      authenticatedAxios.post<VehicleSummariesResponse>(endpoint, { query, variables: {} });

    let response = await postSummaries(getVehicleSummariesQuery);

    // Backward-compatible fallback: retry once without isTradeIn so summaries
    // still load if the BFF hasn't shipped the field yet.
    if (isUnknownIsTradeInField(response?.data?.errors)) {
      response = await postSummaries(getVehicleSummariesLegacyQuery);
    }

    response?.data?.errors?.forEach(error => {
      throw error;
    });
    return response.data.data;
  },

  customerReportVehicleOutcome: async (
    acquisitionName: string,
    outcome: 'MarkedSold' | 'MarkedRemoved'
  ) => {
    const response = await authenticatedAxios.post(endpoint, {
      query: customerReportVehicleOutcomeMutation,
      variables: { input: { acquisitionName, outcome } }
    });
    response?.data?.errors?.forEach((error: unknown) => {
      throw error;
    });
    return response.data.data;
  }
};

export default AppraisalBffApi;
